import React, { Component } from 'react';
import API from '../../../api/api';
import './userRule.less';
import zhCN from 'antd/es/locale/zh_CN';
import { Form, Button, Input, Icon, Radio, ConfigProvider, message } from 'antd';

class UserRule extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        loading: false,
        itemList: [],
        itemType: '', // 1、新用户。2、老用户
        ruleId: '',
        params: {},
    }

    componentDidMount() {
        console.log('this.porps', this.getQueryString('a'), this.getQueryString('b'))
        let itemType = this.getQueryString('itemType');
        let ruleId = this.getQueryString('ruleId');
        this.setState({ itemType, ruleId })
        let params = {
            itemType,
            ruleId
        }
        this.ruleDetail(params);

    }

    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }

    async ruleDetail(params) {
        let result = await API.ruleDetail(params);
        if (result.status == 1) {
            this.setState({
                itemList: result.data
            })
        }
    }


    addRule() {
        let { itemList } = this.state;
        let newItem = {
            // itemId: '1',
            startRound: '',
            endRound: '',
            ruleType: 1, // 1、设置奖品。2、复用规则
            mulStartRound: '',
            mulEndRound: '',
            prizeList: [
                {
                    prizeId: '',
                    chance: '',
                },
            ]
        }
        itemList = itemList.concat(newItem);
        this.setState({ itemList })
    }

    changeRadio(index, e) {
        console.log('e', e.target.value)
        let { itemList } = this.state;
        itemList[index].ruleType = e.target.value
        this.setState({ itemList })
    }
    inputChange(name, index, e) {
        console.log('e', e.target.value)
        let { itemList } = this.state;
        itemList[index][name] = e.target.value
        this.setState({ itemList })
    }

    prizeIdChange(name, i, index, e) {
        console.log('e', e.target.value);
        let { itemList } = this.state;
        itemList[index]['prizeList'][i][name] = e.target.value
        this.setState({ itemList })
    }

    addPrizeList(index) {
        let { itemList } = this.state;
        if (itemList[index]['prizeList']) {
            itemList[index]['prizeList'].push({
                prizeId: '',
                chance: '',
            })
        } else {
            itemList[index]['prizeList'] = [
                {
                    prizeId: '',
                    chance: '',
                }
            ]
        }
        this.setState({ itemList })
    }

    remove(i, index) {
        let { itemList } = this.state;
        itemList[index]['prizeList'].splice(i, 1)
        this.setState({ itemList })
    }

    edit() {
        setTimeout(() => {

        }, 2000)
    }


    async edit() {
        this.setState({ loading: true })
        const { itemList, itemType, ruleId } = this.state;

        console.log({ itemType, ruleId, itemList: JSON.stringify(itemList) })
        let result = await API.ruleEdit({ itemType, ruleId, itemList: JSON.stringify(itemList) });
        if (result.status == 1) {
            message.success({
                content: '保存成功',
            });
        } else {
            message.error({
                content: '保存失败',
            });
        }
        this.setState({ loading: false })
    }

    goBack() {
        this.props.history.go(-2)
    }

    render() {
        const {
            itemList,
            loading,
            itemType
        } = this.state;
        return (
            <ConfigProvider locale={zhCN}>

                <div className={`userRule`}>

                    <div className='title'>
                        <Button onClick={this.goBack.bind(this)}>返回</Button>
                        <div className='title-word'> {itemType == '1' ? '新' : '老'}用户规则</div>
                    </div>
                    {
                        itemList && itemList.length > 0 &&
                        itemList.map((item, index) => {
                            return (
                                <Form
                                    name="form1"
                                    key={index}
                                    className='rule-model'
                                >
                                    <Form.Item>
                                        <span>第</span>
                                        <Form.Item
                                            name="year"
                                            rules={[{ required: true }]}
                                            style={{ display: 'inline-block', width: '70px', margin: '0 4px' }}
                                        >
                                            <Input type='number' value={item.startRound} onChange={this.inputChange.bind(this, 'startRound', index)} />
                                        </Form.Item>
                                        <span>次 - 第</span>
                                        <Form.Item
                                            name="month"
                                            rules={[{ required: true }]}
                                            style={{ display: 'inline-block', width: '70px', margin: '0 4px' }}
                                        >
                                            <Input type='number' value={item.endRound} onChange={this.inputChange.bind(this, 'endRound', index)} />
                                        </Form.Item>
                                        <span>次</span>
                                    </Form.Item>

                                    <Form.Item
                                        name="radio-button"
                                        rules={[{ required: true }]}
                                    >
                                        <Radio.Group onChange={this.changeRadio.bind(this, index)} defaultValue={item.ruleType} value={item.ruleType}>
                                            <Radio value={1}>设置奖品</Radio>
                                            <Radio value={2}>复用规则</Radio>
                                        </Radio.Group>
                                    </Form.Item>

                                    {
                                        item.ruleType == 1 && item.prizeList && item.prizeList.length > 0 &&
                                        item.prizeList.map((k, i) => (
                                            <Form.Item key={i}>
                                                <span>奖品ID:</span>
                                                <Form.Item
                                                    name="year"
                                                    rules={[{ required: true }]}
                                                    style={{ display: 'inline-block', width: '180px', margin: '0 4px' }}
                                                >
                                                    <Input placeholder='请输入奖品ID' value={k.prizeId} onChange={this.prizeIdChange.bind(this, 'prizeId', i, index)} />
                                                </Form.Item>
                                                <span>中奖比例:</span>
                                                <Form.Item
                                                    name="month"
                                                    rules={[{ required: true }]}
                                                    style={{ display: 'inline-block', width: '180px', margin: '0 4px' }}
                                                >
                                                    <Input placeholder='请输入0-100的正整数' value={k.chance} onChange={this.prizeIdChange.bind(this, 'chance', i, index)} />
                                                </Form.Item>
                                                {
                                                    item.prizeList.length > 1 ? <Icon
                                                        className="dynamic-delete-button"
                                                        type="minus-circle-o"
                                                        onClick={() => this.remove(i, index)}
                                                    /> : null
                                                }

                                            </Form.Item>
                                        ))
                                    }
                                    {
                                        item.ruleType == 1 &&
                                        <Button type="primary" onClick={this.addPrizeList.bind(this, index)}>添加奖品</Button>
                                    }
                                    {
                                        item.ruleType == 2 &&
                                        <Form.Item>
                                            <span>第</span>
                                            <Form.Item
                                                name="year"
                                                rules={[{ required: true }]}
                                                style={{ display: 'inline-block', width: '70px', margin: '0 4px' }}
                                            >
                                                <Input type='number' value={item.mulStartRound} onChange={this.inputChange.bind(this, 'mulStartRound', index)} />
                                            </Form.Item>
                                            <span>次 - 第</span>
                                            <Form.Item
                                                name="month"
                                                rules={[{ required: true }]}
                                                style={{ display: 'inline-block', width: '70px', margin: '0 4px' }}
                                            >
                                                <Input type='number' value={item.mulEndRound} onChange={this.inputChange.bind(this, 'mulEndRound', index)} />
                                            </Form.Item>
                                            <span>次</span>
                                        </Form.Item>
                                    }
                                </Form>
                            )
                        })
                    }


                    <Button type="primary" className='addRule' onClick={this.addRule.bind(this)}>添加规则</Button>
                    <Button
                        type="primary"
                        onClick={this.edit.bind(this)}
                        loading={loading}
                        className='add'
                    >
                        保存
                    </Button>
                </div>
            </ConfigProvider>
        )
    }
}


export default UserRule;